export default __webpack_public_path__ + "static/media/tip.9818dba5.svg";